<template>
    <search-group :title="'合同查询'" :span="24" :inline="true" :btn-span="6" :btnOffset="18" :multipleLines="true"   @search="findData" @clear="clearValue" >
        <Row class="mb16" :gutter="16">
            <Col span="4">
              <Select v-model="searchData.projectFid" placeholder="请选择项目">
                
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.leaseTime" placeholder="租约类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in leaseTimeeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.renewAgreementState" placeholder="续约意向">
                <Option value=''>请选择</Option>
                <Option v-for="item in renewStateList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="6">
            <DatePicker v-model="signDay" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changeSignDay" placeholder="签约日"></DatePicker>
          </Col>
          <Col span="6">
            <DatePicker v-model="dueDay" placement="bottom-end" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changeDueDay" placeholder="到期日"></DatePicker>
          </Col> 
           
        </Row>
        <Row :gutter="16">
          <Col span="6">
            <Input type="text" v-model="searchData.cusPhoneNumber" placeholder="签约客户、签约手机号、房间号" @keyup.enter.native="findData"></Input>
          </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">

import SearchGroup from 'components/SearchGroup/index';
import {getProjects } from 'api/common'
import { selectCondition} from 'api/contractList'
export default {
  created(){
    this.initCondition()
    // this.findData()
  },
  components: {
    SearchGroup
  },
  data () {
    return {
      searchData:{
        projectFid:'',
        leaseTime:'',
        renewAgreementState:'',
        signEndDate:'',
        signStartDate:'',
        expireStartDate:'',
        expireEndDate:'',
        cusPhoneNumber:'',
        limit: 10,
        page: 1
      },
      signDay:[],
      dueDay:[],
      projectList:[],
      leaseTimeeList:[],
      renewStateList:[],
    }
  },
  methods: {
    changeSignDay(val){
      this.searchData.signStartDate = val[0]
      this.searchData.signEndDate = val[1]
    },
    changeDueDay(val){ 
      this.searchData.expireStartDate = val[0]
      this.searchData.expireEndDate = val[1]
    },
    
    findData() {
      this.$emit('findData',this.searchData)
    },
    clearValue() {
      this.searchData.page = 1
      for (let key in this.searchData){
        if(key ==='page' || key === 'limit'|| key ==='projectFid') continue
        this.searchData[key] = ''
      }
      this.signDay=[]
      this.dueDay = []
    },
    initCondition(){
      getProjects().then( res => {
        this.projectList = res.data
        this.searchData.projectFid = this.projectList[0].value
        this.$emit('findData',this.searchData)
      })
      selectCondition().then( res => {
        this.leaseTimeeList = res.data.leaseTime
        this.renewStateList = res.data.renewState
      })
    },

  }
}
</script>
<style scoped>
.dash {
    text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 60%;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }

.ivu-date-picker {
  width: 100%;
}
</style>

